module.exports = __webpack_public_path__ + "assets/签单数量.f324b96b.svg";